import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  font-family: ${theme.fonts.main};
`;

export const FilterSection = styled.div`
  background: #f8f9fa;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
`;

export const FilterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  margin-bottom: 1rem;
`;

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FilterLabel = styled.label`
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #333;
  font-size: 0.9rem;
`;

export const FilterSelect = styled.select`
  padding: 0.75rem;
  border: 2px solid #e1e5e9;
  border-radius: 8px;
  background: white;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(57, 73, 171, 0.1);
  }

  &:hover {
    border-color: #c1c7cd;
  }
`;

export const ClearFiltersButton = styled.button`
  background: #6c757d;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.3s ease;
  align-self: flex-start;

  &:hover {
    background: #5a6268;
    transform: translateY(-1px);
  }
`;

export const CourseGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 350px));
  gap: 2rem;
  margin-top: 2rem;
  justify-content: center;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(300px, 300px));
    gap: 1.5rem;
  }

  @media (min-width: 1200px) {
    justify-content: flex-start;
  }
`;

export const CourseList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const CourseRow = styled.div`
  display: flex;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  min-height: 200px;

  @media (max-width: 768px) {
    flex-direction: column;
    min-height: auto;
  }
`;

export const CourseImage = styled.div`
  height: 200px;
  width: 300px;
  padding: 1rem;

  background: #f0f2f5;
  position: relative;
  overflow: hideen;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 180px;
  }
`;

export const CourseContent = styled.div`
  padding: 0rem 1rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`;

export const CourseTitle = styled.h3`
  color: #333;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 1rem 0;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
`;

export const CourseDescription = styled.p`
  color: #666;
  font-size: 1rem;
  line-height: 1.6;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 0.95rem;
  }
`;

export const CourseMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: auto;
`;

export const CourseTag = styled.span`
  background: ${props => {
    switch (props.type) {
      case 'year': return '#e3f2fd';
      case 'subject': return '#f3e5f5';
      case 'category': return '#e8f5e8';
      default: return '#f5f5f5';
    }
  }};
  color: ${props => {
    switch (props.type) {
      case 'year': return '#1976d2';
      case 'subject': return '#7b1fa2';
      case 'category': return '#388e3c';
      default: return '#666';
    }
  }};
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;
`;

export const SpecializedList = styled.ul`
  margin: 1rem 0 0 0;
  padding-left: 1.5rem;
  list-style: none;
`;

export const SpecializedItem = styled.li`
  color: #555;
  font-size: 1rem;
  line-height: 1.2;
  margin-bottom: 0.75rem;
  position: relative;
  
  &:before {
    content: '•';
    color: #3949ab;
    font-weight: bold;
    position: absolute;
    left: -1.2rem;
    font-size: 1.2rem;
  }

  @media (max-width: 768px) {
    font-size: 0.95rem;
    margin-bottom: 0.6rem;
  }
`;

export const CourseCount = styled.p`
  text-align: center;
  color: #666;
  font-size: 1.1rem;
  margin: 1rem 0;
  padding: 1rem;
  background: #e8f4fd;
  border-radius: 8px;
  border-left: 4px solid ${theme.colors.primary};
`;

export const NoResults = styled.div`
  text-align: center;
  padding: 3rem;
  color: #666;

  h3 {
    color: #333;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1.1rem;
    line-height: 1.6;
  }
`;

export const Future = styled.div`
  margin-top: 3rem;
  padding: 2rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;

  h3 {
    color: #333;
    margin-bottom: 1rem;
  }

  ul {
    li {
      margin-bottom: 0.5rem;
      color: #555;
    }
  }
`;